module.exports = __webpack_public_path__ + "media/images/icon_dl2-d4cbc1c8ac1f80a145e4be42eea872d4.svg";